/* eslint-disable no-underscore-dangle */
import Vue from 'vue';
/**
 * 由于 Vue 不支持侦听 Set 的变化，所以这里要写一个替代品
 */
export class ObservableSet extends Set {
  notifyDeps() {
    this.__ob__.dep.notify();
  }
  constructor(...args) {
    super(...args);
    Object.defineProperty(this, '__ob__', {
      value: Vue.observable({}).__ob__
    });
  }
  add(value) {
    const exists = this.has(value);
    if (!exists) {
      super.add(value);
      this.notifyDeps();
    }
    return this;
  }
  delete(value) {
    const ans = super.delete(value);
    if (ans) this.notifyDeps();
    return ans;
  }
  clear() {
    const wasEmpty = this.size === 0;
    super.clear();
    if (!wasEmpty) this.notifyDeps();
  }
}
//# sourceMappingURL=ObservableSet.js.map
